/*
 * @Author: YuanYuan
 * @Date: 2025-01-21 11:28:11
 * @LastEditTime: 2025-08-28 17:08:33
 * @Description: 账户总览接口集合
 */
const prefix = process.env.VUE_APP_API_PREFIX

export default [
  {
    name: 'overview',
    path: `${prefix}/user/cost`,
    method: 'get',
    params: {},
    desc: '账户总览数据'
  },
  {
    name: 'changeWarnStatus',
    path: `${prefix}/user/toggle/cost`,
    method: 'get',
    params: {
      useAccountSwitch: ''
    },
    desc: '是否开启预警'
  },
  {
    name: 'updateWarnValue',
    path: `${prefix}/user/update`,
    method: 'post',
    params: {},
    desc: '修改预警值'
  },
  {
    name: 'recharge',
    path: `${prefix}/payment/rechargeConsole`,
    method: 'post',
    params: {
      price: ''
    },
    desc: '支付相关-账户充值-控制台'
  },
  {
    name: 'accountInfo',
    path: `${prefix}/user/getCurrent`,
    method: 'get',
    params: {},
    desc: '基本信息-详情'
  },
  {
    name: 'sendCode',
    path: `${prefix}/message/send/code`,
    method: 'get',
    params: {},
    desc: '安全设置验证码获取'
  },
  {
    name: 'updatePayPwd',
    path: `${prefix}/user/update/paymentPwd`,
    method: 'post',
    params: {
      verifyCode: '',
      paypasswd: ''
    },
    desc: '修改支付密码'
  },
  {
    name: 'updateEmail',
    path: `${prefix}/user/update/email`,
    method: 'get',
    params: {
      verifyCodeOld: '',
      email: '',
      verifyCodeNew: ''
    },
    desc: '修改邮箱'
  },
  {
    name: 'updateLoginPwd',
    path: `${prefix}/user/update/cms/password`,
    method: 'post',
    params: {
      verifyCode: '',
      passwordOld: '',
      passwordNew: ''
    },
    desc: '修改密码'
  },
  {
    name: 'noticeQuery',
    path: `${prefix}/notice/query`,
    method: 'get',
    params: {},
    desc: '通知详情'
  },
  {
    name: 'tgTest',
    path: `${prefix}/notice/testTG`,
    method: 'post',
    params: {
      botName: '',
      token: '',
      tgUserId: '',
      tgGroupId: ''
    },
    desc: '测试机器人'
  },
  {
    name: 'noticeSave',
    path: `${prefix}/notice/save`,
    method: 'post',
    params: {
      configId: '',
      emailStatus: '',
      emails: [],
      lang: '',
      tgStatus: '',
      tgs: []
    },
    desc: '保存通知'
  }
]
